export const authConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    GETTING_CURRENT_USER: 'GETTING_CURRENT_USER',
    
    LOGOUT: 'USERS_LOGOUT'
};